import { Card } from "@/src/components/cards";
import { openConfirmDialog } from "@/src/components/dialogs";
import { Hospitalisation, Patient, Shift } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  formatDate,
  getDayCount,
  getItemId,
  getUserId,
  getUserShortName,
  isToday,
} from "@/src/utils/utils";
import openEvolutionItemStandardForm from "../openEvolutionItemStandardForm";

export default function ShiftCard({
  item,
  patient,
  parent,
  onClick,
  onChange,
}: {
  item: Shift;
  patient: Patient;
  parent: Hospitalisation;
  onClick: () => void;
  onChange: (item: Shift) => void;
}) {
  return (
    <Card
      color={"blue"}
      leading={
        <div className=" mtop5 left br mright5">
          <div className="bold">{getDayCount(parent?._date, item._date)}</div>
          <div className="gray">{formatDate(item._date, "HH:mm")}</div>
        </div>
      }
      title={"Mot de la garde"}
      subTitle={getUserShortName(item?.creator) || ""}
      onEdit={async () => {
        await openEvolutionItemStandardForm({
          item,
          patient,
          onConfirm: async (newItem) => {
            newItem = await apiFetch("shifts", "addOne", {
              shift: newItem,
            });
            onChange?.(newItem);
          },
        });
      }}
      onClick={async () => {
        await onClick();
      }}
      onDelete={
        getUserId() == getItemId(item.creator) && isToday(item._date)
          ? async () => {
              await openConfirmDialog({
                content: "Voulez-vous vraiment supprimer cet élément ?",
                onConfirm: async () => {
                  await apiFetch("shifts", "deleteOne", {
                    id: item.id,
                  });
                  onChange?.(item);
                },
              });
            }
          : undefined
      }
    ></Card>
  );
}
